'use client';

import { Dropdown } from './components/Dropdown/Dropdown';
import { FooterLinks } from './components/FooterLinks/FooterLinks';
import { Logo } from './components/Logo/Logo';
import { PersonalWorkspaceNavLinks, TeamWorkspaceNavLinks } from './components/NavLinks/NavLinks';
import { UpgradeButton } from './components/UpgradeButton/UpgradeButton';
import { SideNavProvider, useSideNav } from './context';
import { sideNavContainerStyle } from './styles.css';
import type { WorkspacePlanType, WorkspaceRole, WorkspaceType } from './types';

interface SideNavProps {
  workspaceId: string;
  /** Name of the current workspace */
  workspaceName: string;
  /** User's role within the current workspace */
  workspaceRole: WorkspaceRole;
  /** Type of workspace, i.e. personal, team or organization */
  workspaceType: WorkspaceType;
  /** Avatar image of the workspace */
  workspaceAvatarUrl?: string;
  /** The type of plan, i.e. free, premium or team */
  planType: WorkspacePlanType;
  /** Description of the user's plan */
  planDescription: string;
  /** Whether to show the Dash home link */
  showDashHome?: boolean;
}

function SideNavContent(props: SideNavProps) {
  const planType = props.planType;
  const { isExpanded, setIsHovered } = useSideNav();

  return (
    <nav
      className={sideNavContainerStyle({ collapsed: !isExpanded })}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Logo />
      <Dropdown {...props} />
      {planType === 'TEAM' ? (
        <TeamWorkspaceNavLinks
          workspaceId={props.workspaceId}
          workspaceRole={props.workspaceRole}
          showDashHome={props.showDashHome}
        />
      ) : (
        <PersonalWorkspaceNavLinks
          workspaceId={props.workspaceId}
          showDashHome={props.showDashHome}
        />
      )}

      {planType === 'TEAM' && <FooterLinks />}
      {planType === 'FREE' && <UpgradeButton />}
    </nav>
  );
}

export function SideNav(props: SideNavProps) {
  return (
    <SideNavProvider>
      <SideNavContent {...props} />
    </SideNavProvider>
  );
}
